import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig } from '@ngx-formly/core';

interface RegulatoryDisclaimerFieldProps extends FormlyFieldProps {
  title?: string;
  description?: string;
}

// noinspection CssUnknownTarget
@Component({
  selector: 'app-label-field',
  template: `
    <div class="disclaimer">
      <p class="disclaimer__title">
        {{ props.title }}
      </p>
      <div
        class="disclaimer__description mb-3"
        [innerHTML]="props.description"></div>
    </div>
  `,
  styles: `
    .disclaimer {
      margin-top: 32px;

      &__title {
        font-size: 16px;
        font-weight: 400;
        color: var(--p-greyscale-300);
        margin-bottom: 8px;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegulatoryDisclaimerFieldComponent extends FieldType<
  FieldTypeConfig<RegulatoryDisclaimerFieldProps>
> {}
